import { createApiClient, createWebTokenStore } from '@ps/api-client';
import { CLIENT_APPS } from '@ps/constants';
import { env } from './env';
import { i18n } from '../i18n';

/** Session key. Each app uses its own, so a driver and a customer session on one device stay separate. */
const SESSION_KEY = 'ps.customer.session';

/**
 * Where the public site lives.
 *
 * A session ending on one of these pages is not a reason to interrupt somebody
 * who was only reading — they are simply signed out from here on.
 */
const PUBLIC_PATHS = [
  '/',
  '/how-it-works',
  '/routes',
  '/safety-info',
  '/faq',
  '/contact',
  '/terms',
  '/privacy',
  '/cancellation-policy',
  '/refund-policy',
  '/community-guidelines',
];

function onPublicPage(): boolean {
  const path = window.location.pathname;
  return PUBLIC_PATHS.includes(path) || path.endsWith('-carpool');
}

export const tokenStore = createWebTokenStore(SESSION_KEY);

export const api = createApiClient({
  baseUrl: env.apiBaseUrl,
  client: CLIENT_APPS.CUSTOMER_WEB,
  tokenStore,
  getLanguage: () => (i18n.language === 'hi' ? 'hi' : 'en'),
  onUnauthenticated: () => {
    // A full navigation, not a router push: it clears any in-memory state that
    // belonged to the signed-out session.
    if (window.location.pathname !== '/login' && !onPublicPage()) {
      window.location.assign('/login');
    }
  },
});
